/* eslint-disable array-callback-return */

import { Checkbox, Paper } from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableRow from '@material-ui/core/TableRow'

const StyledTableRow = withStyles((theme) => ({
  root: {
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.action.hover,
    },
  },
}))(TableRow)

const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
  },
  body: {
    padding: '4px 8px',
  },
}))(TableCell)

const ChecklistGrid2 = (props) => {
  const { data, filteredData, onToggle, edit } = props

  return (
    <Paper>
      <div style={{ overflow: 'auto', height: '550px' }}>
        <Table style={{ tableLayout: 'fixed' }} size="small">
          <TableBody>
            {filteredData.map((item) => (
              <StyledTableRow key={item.id}>
                <StyledTableCell style={{ width: '10%' }}>
                  <Checkbox
                    checked={item.autorizacion === 1}
                    onChange={() => onToggle(item.id, item.autorizacion, item.descripcion)}
                    disabled={!edit ? true : data.data.activado === 0}
                    size="small"
                  />
                </StyledTableCell>
                <StyledTableCell align="left" style={{ width: '20%' }}>
                  {item.descripcion}
                </StyledTableCell>
              </StyledTableRow>
            ))}
          </TableBody>
        </Table>
      </div>
    </Paper>
  )
}

export default ChecklistGrid2
